import { useStyles } from 'components/shared/form/FocusTrap/FocusTrap.styles';
import { FocusTrapProps } from 'components/shared/form/FocusTrap/FocusTrap.types';
import React, { FC } from 'react';

export const FocusTrap: FC<FocusTrapProps> = (props) => {
  const classes = useStyles();

  return <input type="text" onFocus={() => props.handler()} className={classes.input} />;
};
